'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Modal } from '@common/components';
import { useOverlayHistory } from '@/hooks/useOverlayHistory';
interface RouletteConfirmModalProps {
  opened: boolean;
  requiredPoint: number;
  balance?: number | null;
  onClose: () => void;
  onConfirm: () => void;
}
const formatPartnerPoint = (point: number) => `${point.toLocaleString()}P`;
export const RouletteConfirmModal = t0 => {
  const $ = _c(32);
  const {
    opened,
    requiredPoint,
    balance,
    onClose,
    onConfirm
  } = t0;
  useOverlayHistory(opened, onClose);
  let t1;
  if ($[0] !== requiredPoint) {
    t1 = formatPartnerPoint(requiredPoint);
    $[0] = requiredPoint;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      label: "\uCC28\uAC10 \uC81C\uD734\uD3EC\uC778\uD2B8",
      value: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== balance || $[5] !== requiredPoint) {
    t3 = typeof balance !== "number" ? [] : [{
      label: "\uBCF4\uC720 \uC81C\uD734\uD3EC\uC778\uD2B8",
      value: formatPartnerPoint(balance)
    }, {
      label: "\uCC38\uC5EC \uD6C4 \uC794\uC561",
      value: formatPartnerPoint(Math.max(0, balance - requiredPoint))
    }];
    $[4] = balance;
    $[5] = requiredPoint;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = [t2, ...t3];
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const rows = t4;
  let t5;
  if ($[10] !== onClose) {
    t5 = <Button theme="sub-line" className="flex-1" onClick={onClose}>취소</Button>;
    $[10] = onClose;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== onConfirm) {
    t6 = <Button className="flex-1" onClick={onConfirm}>참여하기</Button>;
    $[12] = onConfirm;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <div className="flex w-full gap-8">{t5}{t6}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== requiredPoint) {
    t8 = requiredPoint.toLocaleString();
    $[17] = requiredPoint;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t8) {
    t9 = <h2 className="text-center font-700 text-Gray-900 typo-body1">{t8} 제휴포인트가 차감돼요</h2>;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== rows) {
    t10 = <dl className="flex flex-col gap-8 rounded-small bg-Gray-50 p-16">{rows.map(_temp)}</dl>;
    $[21] = rows;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <p className="text-center font-600 text-R-500 typo-caption1">미당첨이어도 제휴포인트는 돌려받을 수 없어요</p>;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t9) {
    t12 = <div className="flex flex-col gap-20">{t9}{t10}{t11}</div>;
    $[24] = t10;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== onClose || $[28] !== opened || $[29] !== t12 || $[30] !== t7) {
    t13 = <Modal opened={opened} onClose={onClose} buttonFooter={t7}>{t12}</Modal>;
    $[27] = onClose;
    $[28] = opened;
    $[29] = t12;
    $[30] = t7;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  return t13;
};
function _temp(t0) {
  const {
    label,
    value
  } = t0;
  return <div key={label} className="flex items-center justify-between"><dt className="font-500 text-Gray-600 typo-body4">{label}</dt><dd className="font-700 text-Gray-900 typo-body4">{value}</dd></div>;
}